module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEGSURBVHgBnY67TgJREIbPDC5qIdlHWB/BREnWRgqzWQmusdFWex/ATl6B+ACWdoZ4y24FNtJADhUJFduTEAgFEHbncFsu4X74qsnMfPMPsICrvMXJozII79nWbZdtAU4qYCoqeA/hcMbIGAk5eYoWihx8xbn1wnaQhwhiSbNgVcycqUnLA6D/BSgKv/xPPEnLowugKvv4Gi/cvMV4TJWTAwQTD4cU4cbf9bG0HKCFjuBjV9kFDx+lZer47y3Ek99oujju7W3h1alLSef8JzU/WC8DK4oO3jr6p7tsvPJt8ilVK3UvbD3trtpZSBY+VfuJd070O8s2gDNJdUGUbTbap/bZZnFADznHVtpFWZVCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/automation/action.png
// module id = l4ed
// module chunks = 46